import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationMacListComponent } from 'src/app/public-utility/organization/components/organization-mac-list/organization-mac-list.component';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [OrganizationMacListComponent],
  exports: [OrganizationMacListComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    MatIconModule,
  ],
})
export class OrganizationMacListModule {}
